const About = () => {
    return (
        <div>
            <h1>Podcast Show</h1>
        </div>
    );
}
 
export default About;